import { render, staticRenderFns } from "./WillOfWorkView.vue?vue&type=template&id=b5080460&scoped=true&"
import script from "./WillOfWorkView.vue?vue&type=script&lang=js&"
export * from "./WillOfWorkView.vue?vue&type=script&lang=js&"
import style0 from "./WillOfWorkView.vue?vue&type=style&index=0&id=b5080460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5080460",
  null
  
)

export default component.exports